import script from "./fundPage.vue?vue&type=script&setup=true&lang=js"
export * from "./fundPage.vue?vue&type=script&setup=true&lang=js"

import "./fundPage.vue?vue&type=style&index=0&id=1b977514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b977514"]])

export default __exports__